import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-collapse';

import mapLegendColors from '../../assets/map-legend-colors.json';

class Legend extends Component {
  static propTypes = {
    isOpened: PropTypes.bool.isRequired,
    toggleLegend: PropTypes.func.isRequired,
  }

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleLegend();
  }

  renderLegendItems() {
    return mapLegendColors.map(item => {
      const { name, hex, image, texture } = item;
      let itemStyle;

      if (hex && texture) {
        itemStyle = {
          background: `url(/static/assets/icons/${texture}) repeat, ${hex}`,
        };
      } else if (image) {
        itemStyle = {
          background: `url(/static/assets/icons/${image})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        };
      } else {
        itemStyle = {
          background: hex,
        };
      }

      return (
        <li key={name} className="legend-item">
          <span className="legend-item-box" style={itemStyle} />
          <p className="legend-desc">{name}</p>
        </li>
      );
    });
  }

  render() {
    const { isOpened } = this.props;
    const legendCloseStyle = {};

    return (
      <div className="Legend">
        <div className="legend-header">
          <p className="title">Map Legend</p>
          <span className="legend-close">
            <button aria-expanded={isOpened} aria-label="Map Legend" onClick={() => this.handleClick()}>
              { isOpened ? '×' : 'o'}
            </button>
          </span>
        </div>
        <Collapse isOpened={isOpened}>
          <ul className="legend-list">
            { this.renderLegendItems() }
          </ul>
          <p className="credits-disclaimer">
            <a href="/about-us/about-the-map/">Credits and disclaimer</a>
            &nbsp;
            &bull;
            &nbsp;
            <a href="/glossary/">Glossary</a>
          </p>
        </Collapse>
      </div>
    );
  }
}

export default Legend;



// WEBPACK FOOTER //
// ./map/components/Legend.js